/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";

export type PROJECT_STATUS = "DONE" | "HALTED" | "OPPORTUNITY" | "PLANNING" | "RUNNING" | "%future added value";
export type AttachProjectToProgramInput = {
    programId: string;
    projectIds?: Array<string | null> | null | undefined;
    csrfToken?: string | null | undefined;
    socketClientId?: string | null | undefined;
    clientMutationId?: string | null | undefined;
};
export type attachProjectToProgramMutationVariables = {
    input: AttachProjectToProgramInput;
};
export type attachProjectToProgramMutationResponse = {
    readonly attachProjectToProgram: {
        readonly program: {
            readonly node: {
                readonly id: string;
                readonly name: string | null;
                readonly description: string | null;
                readonly prefix: string | null;
                readonly color: string | null;
                readonly startDate: string | null;
                readonly endDate: string | null;
                readonly projects: {
                    readonly edges: ReadonlyArray<{
                        readonly node: {
                            readonly id: string;
                            readonly serviceCompanyId: number | null;
                            readonly companyProjectId: number | null;
                            readonly legacyProjectAsSingleProject: {
                                readonly id: string;
                                readonly customProjectId: string | null;
                            } | null;
                            readonly name: string | null;
                            readonly prefix: string | null;
                            readonly color: string | null;
                            readonly startDate: string | null;
                            readonly endDate: string | null;
                            readonly stage: PROJECT_STATUS | null;
                            readonly clients: {
                                readonly edges: ReadonlyArray<{
                                    readonly node: {
                                        readonly id: string;
                                        readonly name: string | null;
                                        readonly logoId: string | null;
                                    } | null;
                                } | null> | null;
                            } | null;
                            readonly status: {
                                readonly edges: ReadonlyArray<{
                                    readonly node: {
                                        readonly id: string;
                                        readonly description: string | null;
                                        readonly color: string | null;
                                        readonly addedAt: string | null;
                                    } | null;
                                } | null> | null;
                            } | null;
                            readonly currentProjectStatus: {
                                readonly id: string;
                                readonly color: string | null;
                                readonly description: string | null;
                                readonly person: {
                                    readonly id: string;
                                    readonly firstName: string | null;
                                    readonly lastName: string | null;
                                    readonly profilePictureId: string | null;
                                } | null;
                            } | null;
                            readonly financialNumbers: {
                                readonly allActualTimeAndExpenses: number | null;
                                readonly recognitionProfitPercentage: number | null;
                                readonly allTotalTimeAndExpensesAtCompletion: number | null;
                            } | null;
                            readonly financialNumbersToDate: {
                                readonly recognitionProfitPercentage: number | null;
                            } | null;
                            readonly totalRevenueRecognition: number | null;
                            readonly totalRevenueRecognitionToDate: number | null;
                            readonly totalTimeRevenueRecognitionToDate: number | null;
                            readonly totalBillableExpensesAtCompletion: number | null;
                            readonly settings: {
                                readonly edges: ReadonlyArray<{
                                    readonly node: {
                                        readonly id: string;
                                        readonly name: string | null;
                                        readonly value: string | null;
                                    } | null;
                                } | null> | null;
                            } | null;
                            readonly userRelationTypes: ReadonlyArray<string | null> | null;
                        } | null;
                    } | null> | null;
                } | null;
                readonly projectsFinancialsTotals: {
                    readonly recognitionForecastRevenue: number | null;
                    readonly allActualTimeAndExpenses: number | null;
                    readonly allTotalTimeAndExpensesAtCompletion: number | null;
                    readonly recognitionProfitPercentage: number | null;
                    readonly recognitionActualProfitPercentage: number | null;
                } | null;
                readonly projectsFinancialsToDate: {
                    readonly totalActualRevenueRecognition: number | null;
                    readonly recognitionAmount: number | null;
                    readonly recognitionActualProfitPercentage: number | null;
                    readonly allActualTimeAndExpenses: number | null;
                } | null;
            } | null;
        } | null;
    } | null;
};
export type attachProjectToProgramMutation = {
    readonly response: attachProjectToProgramMutationResponse;
    readonly variables: attachProjectToProgramMutationVariables;
};



/*
mutation attachProjectToProgramMutation(
  $input: AttachProjectToProgramInput!
) {
  attachProjectToProgram(input: $input) {
    program {
      node {
        id
        name
        description
        prefix
        color
        startDate
        endDate
        projects(first: 10000) {
          edges {
            node {
              id
              serviceCompanyId
              companyProjectId
              legacyProjectAsSingleProject {
                id
                customProjectId
              }
              name
              prefix
              color
              startDate
              endDate
              stage
              clients {
                edges {
                  node {
                    id
                    name
                    logoId
                  }
                }
              }
              status {
                edges {
                  node {
                    id
                    description
                    color
                    addedAt
                  }
                }
              }
              currentProjectStatus {
                id
                color
                description
                person {
                  id
                  firstName
                  lastName
                  profilePictureId
                }
              }
              financialNumbers {
                allActualTimeAndExpenses
                recognitionProfitPercentage
                allTotalTimeAndExpensesAtCompletion
              }
              financialNumbersToDate {
                recognitionProfitPercentage
              }
              totalRevenueRecognition
              totalRevenueRecognitionToDate
              totalTimeRevenueRecognitionToDate
              totalBillableExpensesAtCompletion
              settings {
                edges {
                  node {
                    id
                    name
                    value
                  }
                }
              }
              userRelationTypes
              __typename
            }
            cursor
          }
          pageInfo {
            endCursor
            hasNextPage
          }
        }
        projectsFinancialsTotals {
          recognitionForecastRevenue
          allActualTimeAndExpenses
          allTotalTimeAndExpensesAtCompletion
          recognitionProfitPercentage
          recognitionActualProfitPercentage
        }
        projectsFinancialsToDate {
          totalActualRevenueRecognition
          recognitionAmount
          recognitionActualProfitPercentage
          allActualTimeAndExpenses
        }
      }
    }
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input",
    "type": "AttachProjectToProgramInput!"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "description",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "prefix",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "color",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "startDate",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "endDate",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "allActualTimeAndExpenses",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "recognitionProfitPercentage",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "allTotalTimeAndExpensesAtCompletion",
  "storageKey": null
},
v12 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "ProjectServiceProjectTypeEdge",
    "kind": "LinkedField",
    "name": "edges",
    "plural": true,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "ProjectServiceProjectType",
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "serviceCompanyId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "companyProjectId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "ProjectType",
            "kind": "LinkedField",
            "name": "legacyProjectAsSingleProject",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "customProjectId",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          (v3/*: any*/),
          (v5/*: any*/),
          (v6/*: any*/),
          (v7/*: any*/),
          (v8/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "stage",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "ClientTypeConnection",
            "kind": "LinkedField",
            "name": "clients",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "ClientTypeEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Client",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v2/*: any*/),
                      (v3/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "logoId",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "ProjectServiceProjectStatusTypeConnection",
            "kind": "LinkedField",
            "name": "status",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "ProjectServiceProjectStatusTypeEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ProjectServiceProjectStatusType",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v2/*: any*/),
                      (v4/*: any*/),
                      (v6/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "addedAt",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "ProjectStatus",
            "kind": "LinkedField",
            "name": "currentProjectStatus",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v6/*: any*/),
              (v4/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "Person",
                "kind": "LinkedField",
                "name": "person",
                "plural": false,
                "selections": [
                  (v2/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "firstName",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "lastName",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "profilePictureId",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "FinancialNumbers",
            "kind": "LinkedField",
            "name": "financialNumbers",
            "plural": false,
            "selections": [
              (v9/*: any*/),
              (v10/*: any*/),
              (v11/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "FinancialNumbers",
            "kind": "LinkedField",
            "name": "financialNumbersToDate",
            "plural": false,
            "selections": [
              (v10/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "totalRevenueRecognition",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "totalRevenueRecognitionToDate",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "totalTimeRevenueRecognitionToDate",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "totalBillableExpensesAtCompletion",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "ProjectServiceProjectSettingTypeConnection",
            "kind": "LinkedField",
            "name": "settings",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "ProjectServiceProjectSettingTypeEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ProjectServiceProjectSettingType",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v2/*: any*/),
                      (v3/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "value",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "userRelationTypes",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "__typename",
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "cursor",
        "storageKey": null
      }
    ],
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "concreteType": "PageInfo",
    "kind": "LinkedField",
    "name": "pageInfo",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "endCursor",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "hasNextPage",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
],
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "recognitionActualProfitPercentage",
  "storageKey": null
},
v14 = {
  "alias": null,
  "args": null,
  "concreteType": "FinancialNumbers",
  "kind": "LinkedField",
  "name": "projectsFinancialsTotals",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "recognitionForecastRevenue",
      "storageKey": null
    },
    (v9/*: any*/),
    (v11/*: any*/),
    (v10/*: any*/),
    (v13/*: any*/)
  ],
  "storageKey": null
},
v15 = {
  "alias": null,
  "args": null,
  "concreteType": "FinancialNumbers",
  "kind": "LinkedField",
  "name": "projectsFinancialsToDate",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "totalActualRevenueRecognition",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "recognitionAmount",
      "storageKey": null
    },
    (v13/*: any*/),
    (v9/*: any*/)
  ],
  "storageKey": null
},
v16 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 10000
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "attachProjectToProgramMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "AttachProjectToProgramPayload",
        "kind": "LinkedField",
        "name": "attachProjectToProgram",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "ProjectServiceProgramTypeEdge",
            "kind": "LinkedField",
            "name": "program",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "ProgramType",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  (v2/*: any*/),
                  (v3/*: any*/),
                  (v4/*: any*/),
                  (v5/*: any*/),
                  (v6/*: any*/),
                  (v7/*: any*/),
                  (v8/*: any*/),
                  {
                    "alias": "projects",
                    "args": null,
                    "concreteType": "ProjectServiceProjectTypeConnection",
                    "kind": "LinkedField",
                    "name": "__Program_projects_connection",
                    "plural": false,
                    "selections": (v12/*: any*/),
                    "storageKey": null
                  },
                  (v14/*: any*/),
                  (v15/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "attachProjectToProgramMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "AttachProjectToProgramPayload",
        "kind": "LinkedField",
        "name": "attachProjectToProgram",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "ProjectServiceProgramTypeEdge",
            "kind": "LinkedField",
            "name": "program",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "ProgramType",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  (v2/*: any*/),
                  (v3/*: any*/),
                  (v4/*: any*/),
                  (v5/*: any*/),
                  (v6/*: any*/),
                  (v7/*: any*/),
                  (v8/*: any*/),
                  {
                    "alias": null,
                    "args": (v16/*: any*/),
                    "concreteType": "ProjectServiceProjectTypeConnection",
                    "kind": "LinkedField",
                    "name": "projects",
                    "plural": false,
                    "selections": (v12/*: any*/),
                    "storageKey": "projects(first:10000)"
                  },
                  {
                    "alias": null,
                    "args": (v16/*: any*/),
                    "filters": [],
                    "handle": "connection",
                    "key": "Program_projects",
                    "kind": "LinkedHandle",
                    "name": "projects"
                  },
                  (v14/*: any*/),
                  (v15/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": null,
    "metadata": {
      "connection": [
        {
          "count": null,
          "cursor": null,
          "direction": "forward",
          "path": [
            "attachProjectToProgram",
            "program",
            "node",
            "projects"
          ]
        }
      ]
    },
    "name": "attachProjectToProgramMutation",
    "operationKind": "mutation",
    "text": "mutation attachProjectToProgramMutation(\n  $input: AttachProjectToProgramInput!\n) {\n  attachProjectToProgram(input: $input) {\n    program {\n      node {\n        id\n        name\n        description\n        prefix\n        color\n        startDate\n        endDate\n        projects(first: 10000) {\n          edges {\n            node {\n              id\n              serviceCompanyId\n              companyProjectId\n              legacyProjectAsSingleProject {\n                id\n                customProjectId\n              }\n              name\n              prefix\n              color\n              startDate\n              endDate\n              stage\n              clients {\n                edges {\n                  node {\n                    id\n                    name\n                    logoId\n                  }\n                }\n              }\n              status {\n                edges {\n                  node {\n                    id\n                    description\n                    color\n                    addedAt\n                  }\n                }\n              }\n              currentProjectStatus {\n                id\n                color\n                description\n                person {\n                  id\n                  firstName\n                  lastName\n                  profilePictureId\n                }\n              }\n              financialNumbers {\n                allActualTimeAndExpenses\n                recognitionProfitPercentage\n                allTotalTimeAndExpensesAtCompletion\n              }\n              financialNumbersToDate {\n                recognitionProfitPercentage\n              }\n              totalRevenueRecognition\n              totalRevenueRecognitionToDate\n              totalTimeRevenueRecognitionToDate\n              totalBillableExpensesAtCompletion\n              settings {\n                edges {\n                  node {\n                    id\n                    name\n                    value\n                  }\n                }\n              }\n              userRelationTypes\n              __typename\n            }\n            cursor\n          }\n          pageInfo {\n            endCursor\n            hasNextPage\n          }\n        }\n        projectsFinancialsTotals {\n          recognitionForecastRevenue\n          allActualTimeAndExpenses\n          allTotalTimeAndExpensesAtCompletion\n          recognitionProfitPercentage\n          recognitionActualProfitPercentage\n        }\n        projectsFinancialsToDate {\n          totalActualRevenueRecognition\n          recognitionAmount\n          recognitionActualProfitPercentage\n          allActualTimeAndExpenses\n        }\n      }\n    }\n  }\n}\n"
  }
};
})();
(node as any).hash = '86227cc225aef31fc587f5759bc77f56';
export default node;
